import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromHelpStore from './help-store.reducer';
import { EffectsModule } from '@ngrx/effects';
import { HelpStoreEffects } from './help-store.effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromHelpStore.helpStoreFeatureKey, fromHelpStore.reducer),
    EffectsModule.forFeature([HelpStoreEffects])
  ]
})
export class HelpStoreModule { }
